import ConfirmButtonMobile from "./ConfirmButtonMobile";

export default ConfirmButtonMobile;
